export default "__VITE_ASSET__sZQzK$$L__"